var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_139981",
    "data-name": "Group 139981",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.582,
    height: 28.582,
    viewBox: "0 0 28.582 28.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 11.39,
    cy: 11.39,
    r: 11.39,
    transform: "translate(2.591 2.629)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-Media-Collection"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youtube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-207",
    d: "M21.437,14.831a21.622,21.622,0,0,1-.143,2.313,3.09,3.09,0,0,1-.568,1.418,2.041,2.041,0,0,1-1.432.6c-2,.145-5,.149-5,.149s-3.716-.034-4.859-.143a2.425,2.425,0,0,1-1.576-.611,3.09,3.09,0,0,1-.568-1.418,21.622,21.622,0,0,1-.143-2.313V13.746a21.594,21.594,0,0,1,.143-2.312,3.092,3.092,0,0,1,.568-1.419,2.041,2.041,0,0,1,1.432-.6c2-.145,5-.145,5-.145h.005s3,0,5,.145a2.041,2.041,0,0,1,1.432.6,3.092,3.092,0,0,1,.568,1.419,21.594,21.594,0,0,1,.143,2.312ZM14.291,0A14.291,14.291,0,1,0,28.582,14.291,14.291,14.291,0,0,0,14.291,0Z",
    fill: "#ea412c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-208",
    d: "M28.7,31.174l3.861-2-3.862-2.015Z",
    transform: "translate(-15.879 -15.029)",
    fill: "#ea412c",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bcbb29b18afc24365006f6858821bc23.svg";
export { ForwardRef as ReactComponent };